export enum WebCommands {
    ADD_US_TO_BOOKMARK = 'addUsToBookmark',
    ANALYTICS_EVENT = 'analyticsEvent',
    CALL_TEST = 'callTest',
    CITY_LEVEL_UP = 'cityLevelUp',
    CLOSE_AGREEMENT_POPUP = 'closeAgreementPopup',
    DONT_KILL_ME_PLS = 'dontKillMePls',
    EVENT_100_CLICKS = 'event100clicks',
    EVENT_FIRST_BUY = 'eventFirstBuy',
    EVENT_PAYMENT_FINISHED = 'eventPaymentFinished',
    EVENT_REBILL_BUY = 'eventRebillBuy',
    EVENT_SERVER_LOGIN = 'eventServerLogin',
    EVENT_SUCCESS_BUY = 'eventSuccessBuy',
    FB_CAPITOL_UPGRADED = 'fbCapitolUpgraded',
    FB_TUTORIAL_COMPLETE = 'fbTutorialComplete',
    GET_CONSENT_STATE = 'getConsentState',
    GET_FACEBOOK_ACCESS_TOKEN = 'getFacebookAccessToken',
    GET_GOOGLE_ACCESS_TOKEN = 'getGoogleAccessToken',
    GET_START_DATA = 'getStartData',
    GET_START_SHORT_DATA = 'getStartShortData',
    GET_MAINTENANCE_DATA = 'getMaintenanceData',
    HERO_LEVEL_UP = 'heroLevelUp',
    OPEN_POLICY_WINDOW = 'openPolicyWindow',
    PAY = 'pay',
    OPEN_POLLING_WINDOW = 'pollingRequest',
    OPEN_SUPPORT_WIDGET = 'openSupportWidget',
    PAYMENT_WINDOW_ICON_CLICK = 'paymentWindowIconClick',
    SEND_TUTOR_COMPLETED = 'sendTutorCompleted',
    SET_CONSENT_STATE = 'setConsentState',
    SET_CLIPBOARD_CONTENT = 'setClipboardContent',
    SET_PAYER_FLAG = 'setPayerFlag',
    SET_PAYER_INFO = 'setPayerInfo',
    SET_PRELOADER_HINT = 'setPreloaderHint',
    SET_PRELOADER_PROGRESS = 'setPreloaderProgress',
    SET_REGISTRATION_REF = 'setRegistrationRef',
    SET_TUTOR_FINISHED = 'setTutorFinished',
    SHOW_CLIENT = 'showClient',

    MARCHES_9 = 'marches9',
    VALOR_MONSTER_1000 = 'valorMonster1000',
    VALOR_MONSTER_1000_PER_MARCH = 'valorMonster1000perMarch',
    UNITS_TRAIN_SILVER_10000 = 'unitsTrainSilver10000',
    MONSTER_LVL_5 = 'monsterLvl5',

    GET_NOTIFICATIONS_STATE = 'getNotificationsState',
    SET_NOTIFICATIONS_STATE = 'setNotificationsState',
    GET_NOTIFICATIONS_BROWSER_STATE = 'getNotificationsBrowserState',

    SET_PRELOADER_BACKGROUND = 'setPreloaderBackground',
    SET_GAME_CLIENT_SIZE = 'setGameClientSize',

    EVENT_STORAGE_OPENED = 'storageOpened',
    EVENT_STORAGE_CLOSED = 'storageClosed',
    EVENT_BANK_OPENED = 'bankOpened',
    EVENT_BANK_CLOSED = 'bankClosed',
    SWITCH_CURRENT_CHARACTER = 'switchCurrentCharacter',
    START_ACCOUNT_LINKING_REWARD = 'startAccountLinkingReward',
    UPDATE_SIMULATED_PLAYER_STATUS = 'updateSimulatedPlayerStatus'
}
